import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TournamentApiService } from '@fantaz/shared/data-access/api';

import * as AdvertisementActions from './advertisement.actions';
import { TournamentType } from '@fantaz/shared/data-access/models';

@Injectable()
export class AdvertisementEffects {
  init$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AdvertisementActions.loadAdvertisement),
        switchMap((options) => {
          return this.tournamentApiService
            .findPromoteTournament(
              {},
              {
                tournamentType: TournamentType.PRIZE,
              },
            )
            .pipe(
              map((data) => {
                return AdvertisementActions.loadAdvertisementSuccess({
                  advertisement: data
                    .filter((t) => t.advertisement)
                    .filter((t) => {
                      // remove ended tournaments
                      if (t.ended) {
                        return false;
                      }
                      return true;
                    }),
                });
              }),
              catchError((error) => {
                console.log(error);
                return of(
                  AdvertisementActions.loadAdvertisementFailure({ error }),
                );
              }),
            );
        }),
      ),
    { dispatch: true },
  );

  constructor(
    private readonly actions$: Actions,
    private tournamentApiService: TournamentApiService,
  ) {}
}
